import "./card.scss";

import Spinner from "../spinner";

interface CardProps {
  title: string;
  description?: string;
  number: number;
  isLoading?: boolean;
  color?: string;
}

function Card({ title, description, number, isLoading, color }: CardProps) {
  return (
    <div
      className={`
    bg-white rounded-xl shadow-md 
    p-6 flex flex-col items-center text-center
    border border-gray-200
    transition-transform duration-300 hover:scale-105
  `}
    >
      <h3 className="text-xl font-medium text-gray-700">{title}</h3>

      <div className="my-2 text-3xl font-bold text-brand">
        {isLoading ? <Spinner /> : <span>{number}</span>}
      </div>

      <p className="mt-2 text-sm text-gray-500">{description}</p>
    </div>
  );
}

export default Card;
